'use strict';
employeeReimbursementsController.$inject = ['$scope', '$q', '$interval', 'dialogHelper', 'reportHelper', 'invoiceService', 'BUSY_MESSAGE'];
angular.module('schoolLinqApp').controller('employeeReimbursementsController', employeeReimbursementsController);

function employeeReimbursementsController($scope, $q, $interval, dialogHelper, reportHelper, invoiceService, BUSY_MESSAGE) {
	var viewModel = getViewModel();
	$scope.vm = viewModel;

	$scope.reportInterval = null;
	$scope.isReportFinished = false;

	$scope.vm.busyPromise = $q.all([$scope.vm.loadEmployees($scope.vm)]);

	function getViewModel() {
		var model = {
			filter: {
				dateFrom: moment().toDate(),
				dateTo: moment().toDate(),
				allDates: false,
				employees: [],
				selectedEmployee: null,
				unPaidOnly: false,
				paidOnly: false,
			},
			busyMessage: BUSY_MESSAGE.Loading,
			busyPromise: null,
			validationErrors: [],
			errors: null,
		};

		function validateReportParams(model) {
			model.validationErrors = [];
			let isValid = true;

			if (model.filter.allDates !== true) {
				if (!model.filter.dateFrom) {
					model.validationErrors.push("Please select a 'From' date.");
					isValid = false;
				}

				if (!model.filter.dateTo) {
					model.validationErrors.push("Please select a 'To' date.");
					isValid = false;
				}

				if (isValid === true && moment(model.filter.dateFrom).startOf('day') > moment(model.filter.dateTo).startOf('day')) {
					model.validationErrors.push('Date Range is invalid!');
					isValid = false;
				}
			}

			return isValid;
		}

		function openReport(model) {
			if (!validateReportParams(model)) {
				dialogHelper.openMessageBox('Employee Reimbursements Report Error!', null, model.validationErrors, 'Warning');
				return false;
			}

			$scope.isReportFinished = false;
			model.busyMessage = BUSY_MESSAGE.GeneratingReport;
			model.busyPromise = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			if (!model.filter.dateFrom) {
				model.filter.dateFrom = moment().toDate();
			}
			if (!model.filter.dateTo) {
				model.filter.dateTo = moment().toDate();
			}

			var report = {
				EmployeeId: model.filter.selectedEmployee.EmployeeId,
				EmployeeNumber: model.filter.selectedEmployee.EmployeeNumber,
				EmployeeName: model.filter.selectedEmployee.EmployeeName,
				AllDates: model.filter.allDates,
				DateFrom: moment(model.filter.dateFrom).format('l'),
				DateTo: moment(model.filter.dateTo).format('l'),
				UnpaidOnly: model.filter.unPaidOnly,
				PaidOnly: model.filter.paidOnly,
			};

			reportHelper.getReport($scope, '/api/fundreports/employeereimbursementsreport', report, 'EmployeeReimbursementsReport.pdf');
		}

		function loadEmployees(model) {
			return invoiceService.getEmployeeList().then(_.partial(finishLoadingEmployees, model));

			function finishLoadingEmployees(model, response) {
				model.filter.employees = response.data.employees;
				model.filter.employees.splice(0, 0, {
					EmployeeName: 'All Employees',
					Id: null,
				});
				model.filter.selectedEmployee = model.filter.employees[0];

				return angular.noop;
			}
		}

		return angular.extend(model, {
			loadEmployees: _.partial(loadEmployees, model),
			openReport: _.partial(openReport, model),
		});
	}
}
